import { mapState, mapGetters } from 'vuex';

const technicianMixin = {
  computed: {
    ...mapState({
      currentAdmin: (state) => state.admin.current,
      partnerList: (state) => state.admin.partnerList,
      partnerSettings: (state) => state.admin.partnerSettings,
      profileFilters: (state) => state.technician.profileFilters,
      technicians: (state) => state.technician.technicians,
      allTechnicians: (state) => state.technician.allTechnicians,
      selectedTech: (state) => state.technician.selectedTech,
      corpOptions: (state) => state.technician.corpOptions,
      actionModalView: (state) => state.technician.actionModalView,
      showActionModal: (state) => state.technician.showActionModal,
      parsingTechs: (state) => state.technician.parsingTechs,
      newTechsUpload: (state) => state.technician.newTechsUpload,
      errorObj: (state) => state.technician.errorObj,
      filters: (state) => state.technician.filters,
      bulkBranchFilters: (state) => state.technician.bulkBranchFilters,
    }),
    ...mapGetters([
      'adminRole',
      'isSmacAdmin',
      'isManufactureAdmin',
      'technicianFilters',
      'technicianBranches',
    ]),
    partnerOptions() {
      if (!this.partnerList.length) {
        return [];
      }
      const list = [];
      this.partnerList.forEach((item) => {
        if (item.id > 0) {
          list.push({ label: item.corporationName, value: item.id });
        }
      });
      return list;
    },
  },
  methods: {
    toggleActionModal(show, view, data) {
      if (!show) {
        this.$store.dispatch('changeTechnicianValues', [{
          field: 'showActionModal',
          value: false,
        },
        {
          field: 'parsingTechs',
          value: false,
        },
        {
          field: 'errorObj',
          value: {},
        },
        {
          field: 'bulkBranchFilters',
          value: [
            {
              key: 'branch',
              active: false,
              label: 'Branch',
              options: [],
              activeOption: {},
              hideClear: false,
            },
          ],
        },
        ]);
      } else {
        const changes = [{
          field: 'showActionModal',
          value: show,
        }, {
          field: 'actionModalView',
          value: view,
        }];
        if (data) {
          changes.push({
            field: 'selectedTech',
            value: data,
          });
        }
        this.$store.dispatch('changeTechnicianValues', changes);
      }
    },
    selectImage(payload) {
      const {
        image,
      } = payload;
      const formData = new FormData();
      formData.append('photo', image);
      this.$store.dispatch('changeTechnicianValue', {
        field: 'imageForm',
        value: formData,
      });
    },
    parseTechUpload(text) {
      this.$store.dispatch('parseTechsUpload', { text });
    },
  },
};

export default technicianMixin;
